'use strict';

var ApplicationMetadataDirective = function ApplicationMetadataDirective(App) {
  return {
    restrict: 'A',
    template: require('../templates/application-metadata.html'),
    link: function link(scope) {
      scope.version = App.version;
    }
  };
};
ApplicationMetadataDirective.$inject = ['App'];
module.exports = ApplicationMetadataDirective;